import { Grid, Icon, Segment } from 'semantic-ui-react';
import styled from 'styled-components'

export const UserProfileLogo = styled.div`
  display: flex;
  flex: 1 1 0%;
  margin-left: 12px;
  align-items: center;
  justify-content: flex-start;
  .farmer-title {
    font-size: 18px !important;
    font-weight: bold !important;
    margin-right: 10px;
  }
  i.big.icon.{
    font-size: 3em !important;
  }
  .farmer-logo-container {
    position: relative;
    flex: none;
    height: 6rem;
    width: 6rem;
  > span {
    position: absolute;
    height: 100%;
    width: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    border-radius: 9999px;
    background: #f5f5f5;
    > img {
      position: absolute;
      height: 100%;
      width: 100%;
      -o-object-fit: scale-down;
      object-fit: scale-down;
      border-radius: 9999px;
      background: #f5f5f5;
    }
    }    
  }
  .farmer-name-container {
    margin-left: 10px;
    .label {
    font-weight: 700 !important;
  }
  }

  .farmer-supplier {
    font-size: 14px !important;
    margin-bottom: 5px;
    font-weight: 700 !important;
  }

  .farmer-company-name {
    font-size: 20px !important;
    font-weight: bold !important;
  }
`;

export const StyledDefaultProfile = styled(Icon)`
font-size: 6em !important;
position: absolute;
top: 50%;
left: 50%;
color: #c3c3c3;
transform: translate(-50%, -50%);
`

export const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
background-color: rgb(241 245 249) !important;
border: none !important;
border-radius: 1.3rem !important;
min-height: 13rem !important;
margin-top: 50px !important;
box-shadow: none !important;
padding-bottom: 20px !important;
 .column {
  -webkit-box-shadow: none !important;  
   box-shadow: none !important;
 }
`

export const StyledGridRow = styled(Grid.Row)`
padding-bottom: 5px !important;
align-items: baseline !important;
flex-wrap: no-wrap !important;
`
export const StyledInfoRow = styled.div`
padding-bottom: 5px !important;
align-items: baseline !important;
flex-wrap: no-wrap !important !important;
width: 100%!important;
padding: 0;
padding-top: 1rem;
display: flex;
`
export const StyledGridColumns = styled(Grid.Row)`
font-weight: bold !important;
 .disabled{
  opacity: 1 !important;
 }
margin-right: 10px !important;
`